var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsBold = function SvgSettingsBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.083 4.126A2.36 2.36 0 0 1 11.432 2h1.137a2.36 2.36 0 0 1 2.349 2.126.36.36 0 0 0 .587.243 2.36 2.36 0 0 1 3.164.158l.804.804a2.36 2.36 0 0 1 .158 3.164.36.36 0 0 0 .243.587A2.36 2.36 0 0 1 22 11.432v1.137a2.36 2.36 0 0 1-2.126 2.348.36.36 0 0 0-.243.588 2.36 2.36 0 0 1-.157 3.164l-.805.804a2.36 2.36 0 0 1-3.164.158.36.36 0 0 0-.587.243A2.36 2.36 0 0 1 12.568 22h-1.136a2.36 2.36 0 0 1-2.35-2.126.36.36 0 0 0-.587-.243c-.938.768-2.307.7-3.164-.158l-.804-.804a2.36 2.36 0 0 1-.158-3.164.36.36 0 0 0-.243-.588A2.36 2.36 0 0 1 2 12.57V11.43a2.36 2.36 0 0 1 2.126-2.349.36.36 0 0 0 .243-.587 2.36 2.36 0 0 1 .158-3.164l.804-.804a2.36 2.36 0 0 1 3.165-.158.36.36 0 0 0 .587-.243ZM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
    fill: "currentColor"
  })));
};
export default SvgSettingsBold;